import {
  FlexRowCenter,
  FlexColumn,
  ScrollableErrorArea,
  ThinScrollbar,
  styled,
} from "@reside/ui";
import {Form} from "formik";

export const FlexRowStyled = styled(FlexRowCenter)`
  margin-top: 1rem;
`;

export const StyledScrollableErrorArea = styled(ScrollableErrorArea)``;

/**
 * The wrapping <form> fills the height given by FacilitySettingsContent
 * (the styled LayoutContent with flex-grow:1 + overflow:hidden).
 */
export const StyledForm = styled(Form)`
  h2 {
    font-size: 17px;
  }
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  min-height: 0;
  overflow: hidden;
`;

/**
 * Mirrors FullHeightRow from ReportingLayout.
 * ThinScrollbar adds the thin-scrollbar CSS; display:flex + overflow:hidden
 * makes both child columns fill the available height.
 */
/** Mirrors FullHeightRow from ReportingLayout. */
export const PageLayout = styled(ThinScrollbar)`
  display: flex;
  flex-grow: 1;
  min-height: 0;
  overflow: hidden;
`;

/**
 * Mirrors ReportingMenuColumn exactly — margin-right for separation, no border.
 */
export const SidebarNav = styled(FlexColumn)`
  flex-grow: 1;
  flex-shrink: 0;
  margin-right: 20px;
  max-width: 280px;
  overflow: auto;
`;

/**
 * Mirrors ReportsColumn — clips overflow; inner ScrollableContent scrolls.
 */
export const ContentPane = styled(FlexColumn)`
  overflow: hidden;
  flex: 2;
`;

/**
 * Mirrors Scrollable from ReportingLayout — the actual scroll container.
 */
export const ScrollableContent = styled.div`
  flex-grow: 1;
  overflow-y: auto;
  padding-bottom: 48px;
`;

/* ── Sidebar primitives ─────────────────────────────────────────────────── */

export const TemplateSelectorWrapper = styled.div`
  padding: 8px 15px 16px;
  border-bottom: 1px solid ${({theme}) => theme.color.borderGray};
  margin-bottom: 8px;
`;

export const TemplateLabel = styled.span`
  display: block;
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: ${({theme}) => theme.color.darkBlue100};
  opacity: 0.45;
  margin-bottom: 4px;
`;

export const TemplateCodeButton = styled.button`
  display: flex;
  align-items: center;
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  font-size: 13px;
  font-weight: 600;
  color: ${({theme}) => theme.color.primary};
  text-decoration: underline;
  text-underline-offset: 2px;

  &:hover {
    opacity: 0.75;
  }
`;

/** Used by FlexRowStyled only — kept for EditFacilityForm compat. */
export const NavSection = styled.div`
  padding: 4px 0;
`;

/** Invisible prop kept for backward-compat — not used in the new sidebar. */
export const NavItemButton = styled.button<{$active: boolean}>``;

/** Invisible prop kept for backward-compat — not used in the new sidebar. */
export const SubNavItemButton = styled.button<{$active: boolean}>``;

/** Invisible prop kept for backward-compat — not used in the new sidebar. */
export const SidebarSectionHeader = styled.div``;
